import { createSlice } from '@reduxjs/toolkit';

const loginSlice = createSlice({
    name: 'main',
    initialState: {
        loggedIn: false,
        userInfo: {
            email: '',
            password: '',
            department: '',
            name: '',
            id: 0,
            patronymic: '',
            position: '',
            role: '',
            surname: '',
            permissions: {
                contracts_manage: '',
                hospitals_manage: '',
                users_manage: '',
                statistic: '',
                users_activity: '',
                scaning_print: '',
            }
        }
    },
    reducers: {
        logIn: (state, action) => {
            state.loggedIn = true;
            state.userInfo = action.payload;
        },
        logOut: (state) => {
            state.loggedIn = false;
            state.userInfo = {
                email: '',
                password: ''
            };
        },
    },
});

export const { logIn, logOut } = loginSlice.actions;
export default loginSlice;
